import React from "react";
import { AggregationOperation } from "../types";

export type AggregationOperationInterfaceComponentProps<
  T extends AggregationOperation,
  S,
> = {
  value: T;
  onChange: (newValue: T) => void;
  disabled?: boolean;
  props?: S;
  inline?: boolean;
  previousValueTypes?: number | string[];
};
type AggregationSettingsHolder<T extends AggregationOperation, S> = {
  label: string;
  description: string;
  type: string;
  ViewComponent: React.FunctionComponent<
    AggregationOperationInterfaceComponentProps<T, S>
  >;
};
export abstract class AggregationSettingInterface<
  T extends AggregationOperation,
  S,
> {
  label: string;
  description: string;
  type: T["action"];

  constructor(type: T["action"]) {
    this.type = type;
  }
  abstract create(): AggregationSettingsHolder<T, S>;
  abstract ViewComponent(): React.FunctionComponent<
    AggregationOperationInterfaceComponentProps<T, S>
  >;
  abstract ExtendedComponent(): React.FunctionComponent<
    AggregationOperationInterfaceComponentProps<T, S>
  >;
}
